<template>
  <div class="group relative flex flex-col">
    <label
      :for="name"
      class="text-sm text-gray-300">
      {{ label }}{{ required ? '*' : '' }}
    </label>
    <select
      :id="name"
      ref="input"
      :name="name"
      :required="required"
      :value="modelValue"
      class="mt-1.5 h-14 rounded-full border-2 border-gray-200 bg-white bg-[right_1rem_center] px-6 py-3 disabled:cursor-wait"
      :class="[modelValue ? 'text-gray-500' : 'text-sm text-gray-250', wasInvalidated ? 'invalid:border-red-400' : '']"
      :disabled="state === FormState.LOADING"
      @input="onChange"
      @invalid="wasInvalidated = true">
      <option
        selected
        value="">
        {{ modelValue ? 'Prekliči izbiro' : placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <span
      v-if="errorMessage && wasInvalidated && !isValid"
      class="absolute bottom-0 -mb-5 text-xs text-red-400"
      >{{ errorMessage }}</span
    >
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from '#imports'

  import { FormState } from '~/constants/form'

  type DropdownProps = {
    state: FormState
    label: string
    placeholder: string
    name: string
    modelValue: string | null
    options: { label: string; value: string }[]
    required?: boolean
    errorMessage?: string
  }

  type DropdownEmits = {
    (event: 'update:modelValue', value: string): void
  }

  defineProps<DropdownProps>()

  const emit = defineEmits<DropdownEmits>()

  // eslint-disable-next-line vue/prefer-use-template-ref
  const input = ref<HTMLSelectElement | null>(null)
  const wasInvalidated = ref(false)
  const isValid = ref<boolean | null>(null)

  function onChange(event: Event) {
    emit('update:modelValue', (event.target as HTMLInputElement).value)
    wasInvalidated.value = false
    isValid.value = input.value.validity.valid
  }

  onMounted(() => {
    isValid.value = input.value.validity.valid
  })
</script>

<style scoped>
  input::placeholder {
    @apply text-gray-250;
  }
</style>
